import { PigeonMap } from 'components/Basic/Map/PigeonMap/PigeonMap';
import { MapyCzLogo } from 'components/Basic/Map/SeznamMap/Attribution/MapyCzLogo';
import { SeznamAttribution } from 'components/Basic/Map/SeznamMap/Attribution/SeznamAttribution';
import { useMapContext } from 'context/Map/useMapContext';
import { useCallback } from 'react';
import { MapProps } from 'types/map';

export const SeznamMap: FC<MapProps> = (props) => {
    const [{ mapProvider }] = useMapContext();

    const mapyCzMapTilesProvider = useCallback(
        (x: number, y: number, z: number, dpr?: number) => {
            return `https://api.mapy.cz/v1/maptiles/basic/256/${z}/${x}/${y}${dpr && dpr >= 2 ? '@2x' : ''}?apikey=${
                mapProvider?.apiKey
            }`;
        },
        [mapProvider],
    );

    if (!mapProvider) {
        return null;
    }

    return (
        <PigeonMap {...props} attribution={<SeznamAttribution />} mapTilesProvider={mapyCzMapTilesProvider}>
            <MapyCzLogo />
        </PigeonMap>
    );
};
